import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ToThink from './pages/to-think';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* future pages */}
      {/* <Route path="/projects" element={<Projects />} /> */}
      {/* <Route path="/about" element={<About />} /> */}

      <Route path="/to-think" element={<ToThink />} />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
